function GetGameName(game){
    if (game == "aw"){
        return "atomicwar";
    }else if (game == "lw"){
        return "kkHero";
   }else if (game == "ym"){
        return "ymmj";
   }else if (game == "party"){
     return "dotaParty";
   }
   else if (game == "luckydefence"){
     return "luckydefence";
   }
   return "";
}

function GetGameProject(game){
  if (game == "aw"){
    return "1";
  }
  if (game == "luckydefence"){
    return "2";
  }
}

function GetGameMoneyName(game){
  if (game == "aw"){
    return "gamemoney";
  }
  if (game == "luckydefence"){
    return "wallet";
  }
}


export {GetGameName,GetGameProject,GetGameMoneyName};